import types from '../actions/types';

const initialState = {
  stops: null,
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_STOPS:
      return Object.assign({}, state, {
        loading: true
      });
    case types.REQUEST_STOPS_FAILED:
      return initialState;
    case types.RECEIVED_STOPS:
      return {
        stops: action.stops,
        loading: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/stops.js